'use client';

import type { FragmentType } from 'src/gql';
import { isNil } from 'es-toolkit';
import { graphql } from 'src/gql';

import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import type { TaxEnrollmentFormFragment } from '../tax-enrollment-form-fragment';
import { TaxEnrollmentDialog } from '../tax-enrollment-dialog';

export const EditTaxEnrollmentDialogQuery = graphql(/* GraphQL */ `
  query EditTaxEnrollmentDialog($salesforceAccountId: String!) {
    household(salesforceAccountId: $salesforceAccountId) {
      ...TaxEnrollmentForm
    }
  }
`);

type EditTaxEnrollmentDialogProps = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly salesforceAccountId: string | null;
};

export function EditTaxEnrollmentDialog({ open, onClose, salesforceAccountId }: EditTaxEnrollmentDialogProps) {
  const { data, loading } = useQueryWithErrorLogging(EditTaxEnrollmentDialogQuery, {
    variables: { salesforceAccountId: salesforceAccountId ?? '' },
    skip: !open || isNil(salesforceAccountId),
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  // Only pass data when dialog is open and we have fresh data (not loading)
  const householdFrag: FragmentType<typeof TaxEnrollmentFormFragment> | undefined =
    open && !loading ? data?.household : undefined;

  return <TaxEnrollmentDialog open={open} onClose={onClose} householdFrag={householdFrag} loading={loading} />;
}
